import React from "react"

export const NoticePageTabs = ({
  current_tab,
  has_parts,
  is_magic_word_invite,
  has_vu_urls,
  mitteilungen_click,
  toggle_parts_modal,
  picked_part,
  set_clicked_disabled_tab,
  set_current_ref,
  set_current_tab,
  tab_ref_correlation,
  teilnahme_click,
  unterlagen_click,
}) => {
  const uebersichtClick = (e) => {
    e.preventDefault()
    set_current_ref(tab_ref_correlation.overview.ref)
    set_current_tab(tab_ref_correlation.overview.tab)
  }

  const unterlagen_clickDisabled = (e) => {
    e.preventDefault()
    set_clicked_disabled_tab("downloads")
    toggle_parts_modal(e)
  }

  const mitteilungen_clickDisabled = (e) => {
    e.preventDefault()
    set_clicked_disabled_tab("messages")
    toggle_parts_modal(e)
  }

  const teilnahme_clickDisabled = (e) => {
    e.preventDefault()
    set_clicked_disabled_tab("details")
    toggle_parts_modal(e)
  }
  return (
    <div className="tabs noticepage-tabs px-3">
      <ul>
        <li
          className={
            current_tab === 0 || picked_part === "none"
              ? "is-active"
              : undefined
          }
        >
          <a
            onClick={uebersichtClick}
            onKeyPress={() => {}}
            aria-label="select auftraggeber"
            href="# "
            className="has-text-mitternachtsblau has-font-weight-bold"
          >
            Übersicht Verfahren
          </a>
        </li>
        <li
          className={
            is_magic_word_invite && !has_vu_urls
              ? "is-disabled"
              : current_tab === 1
              ? "is-active"
              : undefined
          }
        >
          <a
            onClick={
              has_parts && picked_part === "none"
                ? unterlagen_clickDisabled
                : unterlagen_click
            }
            className="has-text-mitternachtsblau has-font-weight-bold"
            target="_blank"
            rel="noopenner noreferrer"
            href="# "
          >
            Unterlagen
          </a>
        </li>
        <li
          className={
            is_magic_word_invite
              ? "is-disabled"
              : current_tab === 2
              ? "is-active"
              : undefined
          }
        >
          <a
            onClick={
              has_parts && picked_part === "none"
                ? mitteilungen_clickDisabled
                : mitteilungen_click
            }
            className="has-text-mitternachtsblau has-font-weight-bold"
            target="_blank"
            rel="noopenner noreferrer"
            href="# "
          >
            Mitteilungen
          </a>
        </li>

        <li
          className={
            is_magic_word_invite
              ? "is-disabled"
              : current_tab === 3
              ? "is-active"
              : undefined
          }
        >
          <a
            onClick={
              has_parts && picked_part === "none"
                ? teilnahme_clickDisabled
                : teilnahme_click
            }
            className="has-text-mitternachtsblau has-font-weight-bold"
            target="_blank"
            rel="noopenner noreferrer"
            href="# "
          >
            Teilnahme & Angebote
          </a>
        </li>
      </ul>
    </div>
  )
}
